import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import './LocalStories.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import { Link } from 'react-router-dom';

const LocalStories = () => {

    useEffect(() => {
        document.title = `Local Stories | Local Bells`;
        document.getElementById('bodywrap').className = 'nelocalstories';
    }, []);

  // State to toggle sidebar visibility
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />   
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={6}>
                                        <h3>Local Stories</h3>
                                    </Col>
                                    <Col md={6} className='cne-box'>
                                        <Link to="/neighbour/add-local-stories" className='cne-link'>+ Publish new story</Link>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <Row className="ls-img-box mx-0">
                                            <Col xs="auto" className='px-0'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ls1.webp'} className="img-fluid" alt="ls1"/>
                                            </Col>                                            
                                            <Col className='ls-img-box-cont'>
                                                <div className='ls-img-box-date'>
                                                    <h6>Neighbor24 | May 31, 2025</h6>
                                                    <span>Local Highlights</span>
                                                </div>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups ?</h6>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups ?</h6>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, ?</h6>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, ?</h6>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, ?</h6>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12}>
                                        <Row className='mx-0'>
                                            <Col xs={12} className='ls-cont-box'>
                                                <div>
                                                    <h6>Article name</h6>
                                                    <h6>11 hr ago</h6>
                                                    <Link to="/"><h6>View Articles</h6></Link>
                                                </div>
                                                <span>Local Highlights</span>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12}>
                                        <Row className='mx-0'>
                                            <Col xs={12} className='ls-cont-box'>
                                                <div>
                                                    <h6>Article name</h6>
                                                    <h6>11 hr ago</h6>
                                                    <Link to="/"><h6>View Articles</h6></Link>
                                                </div>
                                                <span>Local Highlights</span>
                                            </Col>
                                        </Row>
                                    </Col>                                    
                                    <Col xs={12}>
                                        <Row className="ls-img-box mx-0">
                                            <Col xs="auto" className='px-0'>
                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ls2.webp'} className="img-fluid" alt="ls2"/>
                                            </Col>                                            
                                            <Col className='ls-img-box-cont'>
                                                <div className='ls-img-box-date'>
                                                    <h6>Neighbor24 | May 31, 2025</h6>
                                                    <span>Local Highlights</span>
                                                </div>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups ?</h6>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups ?</h6>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, ?</h6>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, ?</h6>
                                                <h6>Lorem ipsum is placeholder text commonly used in the graphic, print, ?</h6>
                                            </Col>
                                        </Row>
                                    </Col>                                    
                                </Row>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default LocalStories;


